module.exports = {
  id: 44,
  name: 'Dragon Walk',
  categories: ['strength', 'core', 'coordination', 'fullBody'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Strength',
  points: 25,
  instructions:
    'Dragon walks are powerful! Get on your hands and feet with your bottom up high, then walk forward with big, powerful steps! This builds incredible full-body strength! Ready to try it?',
  timedInstructions: [
    {
      time: 0,
      text: "Let's do dragon walks! Get on your hands and feet!",
    },
    {
      time: 2,
      text: 'Lift your bottom up high off the ground!',
    },
    {
      time: 4,
      text: 'Keep your core tight and strong!',
    },
    {
      time: 6,
      text: 'Ready for powerful dragon steps! 3, 2, 1, START!',
    },
    // SET 1
    {
      time: 9,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 11,
      text: 'Keep your bottom up high!',
    },
    {
      time: 13,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 15,
      text: 'Big powerful dragon steps!',
    },
    {
      time: 17,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 19,
      text: 'Keep your core tight!',
    },
    {
      time: 21,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 23,
      text: 'Powerful dragon movement!',
    },
    {
      time: 25,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 27,
      text: 'Keep your body strong!',
    },
    {
      time: 29,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 31,
      text: 'Big steps, dragon power!',
    },
    {
      time: 33,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 35,
      text: 'Keep your bottom up high!',
    },
    {
      time: 37,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 39,
      text: 'Powerful dragon steps!',
    },
    {
      time: 41,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 43,
      text: 'Keep your core engaged!',
    },
    {
      time: 45,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 47,
      text: 'Big steps, keep going!',
    },
    {
      time: 49,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 51,
      text: 'Keep your body strong!',
    },
    {
      time: 53,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 55,
      text: 'Powerful dragon movement!',
    },
    {
      time: 57,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 59,
      text: 'Keep your bottom up high!',
    },
    {
      time: 61,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 63,
      text: 'Great job! Take a break',
    },
    {
      time: 66,
      text: 'Breathe in and out',
    },
    {
      time: 69,
      text: 'You just did 15 dragon steps!',
    },
    {
      time: 72,
      text: 'Your full body is getting stronger!',
    },
    {
      time: 75,
      text: 'Keep breathing, you got this!',
    },
    {
      time: 78,
      text: 'Ready for round two!',
    },
    {
      time: 81,
      text: '3, 2, 1, KEEP GOING!',
    },
    // SET 2
    {
      time: 84,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 86,
      text: 'Keep your bottom up high!',
    },
    {
      time: 88,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 90,
      text: 'Big powerful dragon steps!',
    },
    {
      time: 92,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 94,
      text: 'Keep your core tight!',
    },
    {
      time: 96,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 98,
      text: 'Powerful dragon movement!',
    },
    {
      time: 100,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 102,
      text: 'Keep your body strong!',
    },
    {
      time: 104,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 106,
      text: 'Big steps, dragon power!',
    },
    {
      time: 108,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 110,
      text: 'Keep your bottom up high!',
    },
    {
      time: 112,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 114,
      text: 'Powerful dragon steps!',
    },
    {
      time: 116,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 118,
      text: 'Keep your core engaged!',
    },
    {
      time: 120,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 122,
      text: 'Big steps, keep going!',
    },
    {
      time: 124,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 126,
      text: 'Keep your body strong!',
    },
    {
      time: 128,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 130,
      text: 'Powerful dragon movement!',
    },
    {
      time: 132,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 134,
      text: 'Keep your bottom up high!',
    },
    {
      time: 136,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 138,
      text: 'Amazing job! Take another break',
    },
    {
      time: 141,
      text: 'Breathe in and out',
    },
    {
      time: 144,
      text: 'You just did 30 dragon steps total!',
    },
    {
      time: 147,
      text: 'Your strength is incredible!',
    },
    {
      time: 150,
      text: "Keep breathing, you're doing great!",
    },
    {
      time: 153,
      text: 'Ready for round three!',
    },
    {
      time: 156,
      text: '3, 2, 1, KEEP GOING!',
    },
    // SET 3
    {
      time: 159,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 161,
      text: 'Keep your bottom up high!',
    },
    {
      time: 163,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 165,
      text: 'Big powerful dragon steps!',
    },
    {
      time: 167,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 169,
      text: 'Keep your core tight!',
    },
    {
      time: 171,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 173,
      text: 'Powerful dragon movement!',
    },
    {
      time: 175,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 177,
      text: 'Keep your body strong!',
    },
    {
      time: 179,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 181,
      text: 'Big steps, dragon power!',
    },
    {
      time: 183,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 185,
      text: 'Keep your bottom up high!',
    },
    {
      time: 187,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 189,
      text: 'Powerful dragon steps!',
    },
    {
      time: 191,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 193,
      text: 'Keep your core engaged!',
    },
    {
      time: 195,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 197,
      text: 'Big steps, keep going!',
    },
    {
      time: 199,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 201,
      text: 'Keep your body strong!',
    },
    {
      time: 203,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 205,
      text: 'Powerful dragon movement!',
    },
    {
      time: 207,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 209,
      text: 'Keep your bottom up high!',
    },
    {
      time: 211,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 213,
      text: 'Great job! Take a final break',
    },
    {
      time: 216,
      text: 'Breathe in and out',
    },
    {
      time: 219,
      text: 'You just did 45 dragon steps total!',
    },
    {
      time: 222,
      text: "You're a dragon walk warrior!",
    },
    {
      time: 225,
      text: 'Keep breathing, almost done!',
    },
    {
      time: 228,
      text: 'Ready for the final round!',
    },
    {
      time: 231,
      text: '3, 2, 1, FINAL PUSH!',
    },
    // SET 4
    {
      time: 234,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 236,
      text: 'Keep your bottom up high!',
    },
    {
      time: 238,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 240,
      text: 'Big powerful dragon steps!',
    },
    {
      time: 242,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 244,
      text: 'Keep your core tight!',
    },
    {
      time: 246,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 248,
      text: 'Powerful dragon movement!',
    },
    {
      time: 250,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 252,
      text: 'Keep your body strong!',
    },
    {
      time: 254,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 256,
      text: 'Big steps, dragon power!',
    },
    {
      time: 258,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 260,
      text: 'Keep your bottom up high!',
    },
    {
      time: 262,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 264,
      text: 'Powerful dragon steps!',
    },
    {
      time: 266,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 268,
      text: 'Keep your core engaged!',
    },
    {
      time: 270,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 272,
      text: 'Big steps, keep going!',
    },
    {
      time: 274,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 276,
      text: 'Keep your body strong!',
    },
    {
      time: 278,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 280,
      text: 'Powerful dragon movement!',
    },
    {
      time: 282,
      text: 'Right hand forward, left foot forward!',
    },
    {
      time: 284,
      text: 'Keep your bottom up high!',
    },
    {
      time: 286,
      text: 'Left hand forward, right foot forward!',
    },
    {
      time: 288,
      text: 'You did it, dragon walk champion!',
    },
    {
      time: 290,
      text: "Awesome job, you're a dragon master!",
    },
  ],
};
